var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeliveryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 17.936C19.5 19.3167 18.3807 20.436 17 20.436C15.6193 20.436 14.5 19.3167 14.5 17.936C14.5 16.5553 15.6193 15.436 17 15.436C18.3807 15.436 19.5 16.5553 19.5 17.936Z",
    stroke: "#19425A",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 17.936C9.5 19.3167 8.38071 20.436 7 20.436C5.61929 20.436 4.5 19.3167 4.5 17.936C4.5 16.5553 5.61929 15.436 7 15.436C8.38071 15.436 9.5 16.5553 9.5 17.936Z",
    stroke: "#19425A",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 17.936H9.5M19.5 17.936H20.2632C20.4831 17.936 20.5931 17.936 20.6855 17.9245C21.3669 17.8396 21.9036 17.3029 21.9885 16.6216C22 16.5292 22 16.4192 22 16.1992V13.436C22 9.84618 19.0899 6.93604 15.5 6.93604M2 4.43604H12C13.4142 4.43604 14.1213 4.43604 14.5607 4.87537C15 5.31471 15 6.02182 15 7.43604V15.936M2 13.186V15.436C2 16.3707 2 16.838 2.20096 17.186C2.33261 17.4141 2.52197 17.6034 2.75 17.7351C3.09808 17.936 3.56538 17.936 4.5 17.936",
    stroke: "#19425A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 7.43604H8M2 10.436H6",
    stroke: "#19425A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryIcon);
export default __webpack_public_path__ + "static/media/delivery-icon.86fdaa9b508952ce293f6ef7fd13d83c.svg";
export { ForwardRef as ReactComponent };